export var invalidProvider = function (message) { return function () { return Promise.reject(message); }; };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/invalid-dependency/dist-es/invalidProvider.js
// module id = 747
// module chunks = 0